var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "downloadReport" } },
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "体检报告",
            "class-name": "vertical-center-modal",
            "mask-closable": false,
          },
          model: {
            value: _vm.showReportTemplate,
            callback: function ($$v) {
              _vm.showReportTemplate = $$v
            },
            expression: "showReportTemplate",
          },
        },
        [
          _c(
            "p",
            { staticStyle: { "text-align": "left" } },
            [
              _c("MyCheckBox", {
                attrs: {
                  enumList: _vm.reportTemplateList,
                  dataList: _vm.reportTemplateIdList,
                  dataStr: _vm.reportTemplateIds,
                },
                on: {
                  "update:dataList": function ($event) {
                    _vm.reportTemplateIdList = $event
                  },
                  "update:data-list": function ($event) {
                    _vm.reportTemplateIdList = $event
                  },
                  "update:dataStr": function ($event) {
                    _vm.reportTemplateIds = $event
                  },
                  "update:data-str": function ($event) {
                    _vm.reportTemplateIds = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.download } },
                [_vm._v("下载")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }